export default __webpack_public_path__ + "static/media/illustration-algocare-w.4eff9c6c.webp";